/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * A page's own name for the top bar's crumb when the URL cannot give it
 * (a movement's page names the movement). Outside the provider it is a no-op.
 */
import React, { createContext, useContext, useEffect, useState } from "react";

type PageTitleState = [string | null, (title: string | null) => void];

const PageTitleContext = createContext<PageTitleState | null>(null);

export function PageTitleProvider({ children }: { children: React.ReactNode }) {
  const state = useState<string | null>(null);
  return <PageTitleContext.Provider value={state}>{children}</PageTitleContext.Provider>;
}

export function usePageTitle(): string | null {
  return useContext(PageTitleContext)?.[0] ?? null;
}

/** Names the current page while it is mounted. */
export function usePublishPageTitle(title: string | null): void {
  const setTitle = useContext(PageTitleContext)?.[1];
  useEffect(() => {
    if (!setTitle) return undefined;
    setTitle(title);
    return () => setTitle(null);
  }, [setTitle, title]);
}
